import Axios from "../config/Axios";

export const ApiGuardarReportePeriodo = async (data) => {
  try {
    const result = await Axios.post(`/POSTGenerarReportePeriodo`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetReporteByPeriodo = async (data) => {
  try {
    const result = await Axios.get(`/GETReporteByPeriodo`, {
      params: data,
    });
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};
